import { ISAUTHENTICATED } from "../constants/reduxConstants";

const initialState = {
  isAuthenticated: false,
};

const AuthReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ISAUTHENTICATED:
      return {
        ...state,
        isAuthenticated: payload,
      };
    default:
      return state;
  }
};

export default AuthReducer;
